import { ApiResponse } from "../../apiResponse";
import Axios from "../../axios";

// {
//   "day_time": {
//       "saturday": [
//           "2022-11-26T22:00:00.000Z"
//       ]
//   }
// }
export function indexRecitationSchedule(
  telawahId: number | string,
  slotData?: object
): Promise<ApiResponse> {
  return Axios.post(
    `v1/candidates/recitation_schedule_slots/index_available_slots?telawah_id=${telawahId}`,
    slotData
  );
}
